



























import Vue from "vue";
import { PuzzleService } from "../../services";
import { PuzzleResponse, PuzzleListItem } from "vue/types/vue";
import UserPuzzleItem from "@/components/User/UserPuzzleItem.vue";
export default Vue.extend({
  name: "UserPuzzles",
  components: {
    UserPuzzleItem
  },
  data() {
    return {
      puzzles: new Array<PuzzleListItem>(),
      loading: false,
      confirmData: "",
      modalHeader: "",
      modalMessage: "",
      username: this.$route.params.username || this.$store.getters.user
    };
  },
  computed: {
    user: function (): string {
      return this.username;
      //return this.$store.getters.user;
    }
  },
  created: async function (): Promise<void> {
    await this.getPuzzles();
  },
  methods: {
    getPuzzles: async function (): Promise<void> {
      try {
        this.loading = true;
        let response = await PuzzleService.getAllUserPuzzles();
        this.puzzles = response;
      } catch (error: any) {
        this.puzzles = new Array<PuzzleListItem>();
        throw error;
      } finally {
        this.loading = false;
      }
    },
    goto: function (where: string): void {
      this.$router.push({ name: where });
    },
    deletePuzzle: async function (puzzle: PuzzleListItem): Promise<void> {
      this.confirmData = puzzle.id;
      this.modalHeader = "Ta bort kryss?";
      this.modalMessage = `Vill du verkligen ta bort ${puzzle.name}?`;
    },
    confirmDelete: async function (confirmation: any): Promise<void> {
      this.closeModal();
      try {
        if (confirmation.choice) {
          await PuzzleService.deletePuzzle(confirmation.data);
          window.location.reload();
        }
      } catch (error: any) {
        console.log(error);
      }
    },
    closeModal: function (): void {
      this.modalHeader = "";
      this.modalMessage = "";
    }
  }
});
